var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"positioning",style:(_vm.size)},[_c('IFrame',{key:_vm.reloadComponent,attrs:{"id":_vm.item.id,"properties":_vm.propertiesModel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }